import {
    Autocomplete,
    Button,
    Grid,
    TextField,
} from "@mui/material";
import Typography from "@mui/material/Typography";
import axios from "axios";
import { useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

const LinkedFoodItemTab = ({ linkedFoodItems }) => {
    const [selectedFoodItem, setSelectedFoodItem] = useState(null);
    const [rank, setRank] = useState<number | null>(null);
    const [rankList, setRankList] = useState<number[]>([]);
    // const [linkedFoodItemsState, setLinkedFoodItemsState] = useState(linkedFoodItems);

    const updateLinkedFoodItem = async () => {
        if (selectedFoodItem && rank !== null) {
            try {
                const response = await axios.patch(`${process.env.REACT_APP_SECRET}/api/FoodItems/UpdateRankByFoodItemId?id=${selectedFoodItem.linkItemId}&rank=${rank}`)
                console.log(response.data);
                toast.success("Rank Updated");
            } catch (error) {
                console.log(error);
                toast.error("Unable to update rank")
            }
        }
    };

    const handleOnChange = async (foodItemId: string, sectionId: string): Promise<void> => {
        setSelectedFoodItem(linkedFoodItems.find(item => item.linkItemId === foodItemId));

        // Get rank for specific food item
        try {
            const response = await axios.get(`${process.env.REACT_APP_SECRET}/api/FoodItems/GetRankByFoodItemId?id=${foodItemId}`);
            setRank(response.data);
        } catch (error) {
            console.log(error);
        }

        // Get list of rank list
        try {
            const response = await axios.get(`${process.env.REACT_APP_SECRET}/api/FoodItems/GetRankListBySectionId?id=${sectionId}`);
            setRankList(response.data);
        } catch (error) {
            console.log(error);
        }

        console.log("linked food item", foodItemId, sectionId);
    };

    console.log("linked food item", rank);
    console.log("linked food item", rankList);

    return (
        <div>
            <ToastContainer />
            <Grid container sx={{ padding: "0.5rem", display: "flex", alignItems: "center" }} spacing={2}>
                <Grid item xs={2}>
                    <div
                        className="d-flex"
                        style={{ paddingTop: "1rem", gap: "10px" }}
                    >
                        <Typography>Linked Food</Typography>
                    </div>
                </Grid>

                <Grid item xs={7}>
                    <Autocomplete
                        id='restaurant-dropdown'
                        options={linkedFoodItems}
                        className='my-3'
                        getOptionLabel={(option) => option.linkedFoodItemName}
                        onChange={(event, value) => handleOnChange(value?.linkItemId, value?.sectionId)}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                variant='outlined'
                                placeholder="Linked Food"
                                label='Linked Food'
                            />
                        )}
                    />
                </Grid>

                <Grid item xs={3}>
                    <Autocomplete
                        id="rank"
                        options={rankList}
                        value={rank}
                        onChange={(event, newValue) => setRank(newValue)}
                        className="my-3"
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                variant="outlined"
                                placeholder="Rank"
                                label="Rank"
                            />
                        )}
                    />
                </Grid>
            </Grid>

            <Grid container sx={{ padding: "0.5rem" }}>
                <Grid item xs={12}>
                    <div className="d-flex justify-content-end">
                        <Button
                            onClick={() => {
                                updateLinkedFoodItem();
                            }}
                        >
                            Save
                        </Button>
                    </div>
                </Grid>
            </Grid>
        </div>
    );
};

export default LinkedFoodItemTab;
